import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { http } from "@/lib/api";
import { useSite } from "@/context/SiteContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useSite();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    const run = async () => {
      try {
        const { data } = await http.post("/auth/session", { session_id: sid });
        setUser(data);
        window.history.replaceState(null, "", location.pathname);
        navigate(location.pathname || "/genitori", { replace: true, state: { user: data } });
      } catch {
        setUser(null);
        navigate("/genitori", { replace: true });
      }
    };
    run();
  }, [location, navigate, setUser]);

  return <div className="min-h-screen bg-cream" data-testid="auth-callback" />;
}
